import { render, staticRenderFns } from "./GardenerCustomers.vue?vue&type=template&id=ef92af8c&scoped=true"
import script from "./GardenerCustomers.vue?vue&type=script&lang=js"
export * from "./GardenerCustomers.vue?vue&type=script&lang=js"
import style0 from "./GardenerCustomers.vue?vue&type=style&index=0&id=ef92af8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef92af8c",
  null
  
)

export default component.exports